import { Pipe, PipeTransform, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subscription } from 'rxjs';

@Pipe({
  name: 'dayOfWeek',
  standalone: true,
  pure: false,
})
export class DayOfWeekPipe implements PipeTransform {

  locale = signal(this.translate.currentLang);

  private subscriptions: Subscription[] = [];

  constructor(private translate: TranslateService) {
    this.subscriptions.push(
      this.translate.onLangChange.subscribe((e) => this.locale.set(e.lang))
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  transform(value: string | number, ...args: unknown[]): string {
    return moment().day(value).locale(this.locale()).format('ddd');
  }

}
